
@if (isLink) {
  <a href="#" [routerLink]="'/'" class="float-start">
    <img [src]="customLogoSrc" >
  </a>
}
@if (!isLink) {
  <span class="float-start" >
    <img [src]="customLogoSrc" >
  </span>
}
